import { render } from "./DataTableLite.vue?vue&type=template&id=d38b47a0&scoped=true"
import script from "./DataTableLite.vue?vue&type=script&lang=ts"
export * from "./DataTableLite.vue?vue&type=script&lang=ts"

import "./DataTableLite.vue?vue&type=style&index=0&id=d38b47a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d38b47a0"

export default script